import React, { useState, useEffect, TextInput } from "react";
// import ReactDOM from "react-dom";
// import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Check2, Trash2Fill } from 'react-bootstrap-icons';
import { Table, Button, Form, Row, Col } from 'react-bootstrap';
import { useMappedState, useDispatch } from 'redux-react-hook';
import Enums from '../../../enums';
import { useDebounce } from 'use-debounce';

export default function QuestSkipApp(props) {
    const tmpItems = useMappedState(state => state.tmpItems);
    const dispatch = useDispatch();
    const [currentQid, setCurrentQid] = useState(null);
    const [currentOpIdAry, setCurrentOpIdAry] = useState([]);
    const [targetQid, setTargetQid] = useState(null);
    const [tmpPage, setTmpPage] = useState("");
    const [pageValue] = useDebounce(tmpPage, 300);

    useEffect(() => {
        // console.log(tmpItems);
        let tmp = [];
        try {
            tmpItems.forEach((val, index) => {
                if(null!=val.cf.parameters && null!=val.cf.parameters.random
                    && 1==val.cf.parameters.page){
                    tmp.push((index+1));
                }
                
            })
        } catch (e) {
            console.error(e.stack);
            return []
        }
        // console.log( tmp.join(",") );
        setTmpPage(tmp.join(","));
    }, []);

    useEffect(onEndEditing, [pageValue]);

    function onNewQidClick(qid) {
        setCurrentQid(qid);
        setCurrentOpIdAry([]);
        setTargetQid(null);
        setTmpPage("");
    }

    function onQidSelect(e) {
        var options = e.target.parentElement.options;
        var value = [];
        for (var i = 0, l = options.length; i < l; i++) {
            if (options[i].selected) {
                value.push(options[i].value);
            }
        }
        setCurrentOpIdAry(value);
    }

    function onAddRule(e) {
        e.stopPropagation();
        e.preventDefault();
        if (null == currentQid) { alert("請選擇題目"); return; }
        if (currentOpIdAry.length == 0) { alert("請選擇選項"); return; }
        if (null == targetQid) { alert("請選擇目標跳題"); return; }
        try {
            // console.log(e.target.dataset);
            // let qid = parseInt(e.target.dataset.qid);
            // let opIndex = parseInt(e.target.dataset.opindex);
            let qid = currentQid;
            // let opIndex = currentOpIdAry;
            let tmp = JSON.parse(JSON.stringify(tmpItems));
            let defaultQid = qid + 2; //api index starts from 1...=.=
            let targetQidTmp = targetQid + 1; //api index starts from 1...=.=

            if (!tmp[qid].ru) tmp[qid].ru = { bonus: { ty: 0 }, route: { ty: 0 } };
            if (!tmp[qid].ru.route) tmp[qid].ru.route = { ty: 0 };

            if (Enums.E_QUESTION_TYPE.SINGLE == tmp[qid].cf.q_type) {//單選
                tmp[qid].ru.route.ty = 1;
            } else if (Enums.E_QUESTION_TYPE.MULTIPLE == tmp[qid].cf.q_type) { //複選
                tmp[qid].ru.route.ty = 2;
                tmp[qid].ru.route.pr = targetQidTmp;
            }
            // console.log(tmp[qid].cf.q_type, Enums.E_QUESTION_TYPE.SINGLE)

            if (!tmp[qid].ru.route.ta) {
                tmp[qid].ru.route.ta = Array(tmp[qid].op.length).fill(defaultQid);
            }
            for (let opIndex = 0; opIndex < currentOpIdAry.length; opIndex++) {
                tmp[qid].ru.route.ta[currentOpIdAry[opIndex]] = targetQidTmp;
            }
            // setCurrentOpIdAry([]);

            //check if 2 targets
            if (Enums.E_QUESTION_TYPE.MULTIPLE == tmp[qid].cf.q_type) { //複選
                let tmpCheck = false;
                // console.log(tmp[qid]);
                tmp[qid].ru.route.ta.forEach((val, chIndex) => {
                    if (val != defaultQid && val != targetQidTmp) {
                        tmpCheck = true;
                        // console.log(chIndex)
                    }
                });
                if (true == tmpCheck) {
                    // console.log("[onAddRule]", tmpItems);
                    alert("複選目標跳題必須相同");
                    return;
                }
            }
            // console.log("[onAddRule]", qid, targetQid, tmpItems, tmp);
            dispatch({ type: "UPDATE_TMP_ITEM", data: tmp });
        } catch (e) {
            console.warn(e.stack);
        }
    }

    function renderNewRuleQuestion() {
        // console.log(tmpItems);
        let tmp = [];
        try {
            tmpItems.forEach((val, index) => {
                tmp.push(<option key={"q-" + index} onClick={() => onNewQidClick(index)}>
                    {val.ma.content}
                </option>);
            })
        } catch (e) {
            console.error(e.stack);
            return <div>aa</div>
        }

        return (
            <>
                <Form>
                    <Form.Group controlId="form1">
                        <Form.Label>挑選題目 (出發點)</Form.Label>
                        <Form.Control as="select" multiple="true" style={{ minHeight: "180px" }} >
                            {tmp}
                        </Form.Control>
                    </Form.Group>
                </Form>
            </>
        )
    }

    function renderNewRuleOptions() {
        let tmp = [];
        let tmp2 = [];
        try {
            // console.log(tmpItems);
            if (null != currentQid) {
                let val = tmpItems[currentQid];
                // let priority = (<label>-</label>);
                // if (Enums.E_QUESTION_TYPE.SINGLE != val.cf.q_type) {
                //     priority = <label><Check2 /></label>
                // }

                val.op.forEach((opVal, opIndex) => {
                    tmp.push(<option multiple key={"op-" + opIndex} selected={currentOpIdAry.indexOf(opIndex) >= 0} value={opIndex} onClick={onQidSelect}>{(opIndex + 1) + ". " + opVal.na}</option>);
                    // ops.push(<br />);
                });
                // tmp.push(<tr key={"q-" + currentQid}>
                //     <td>{val.ma.content}</td>
                //     <td>{ops}</td>
                //     <td>{priority}</td>
                //     <td></td>
                // </tr>);
                tmpItems.forEach((val, index) => {
                    if (index > (currentQid + 1)) {
                        // let isSelect = targetQid.indexOf(index) >= 0;
                        tmp2.push(<option key={"opTa-" + index} selected={targetQid == index} onClick={() => setTargetQid(index)}> {(index + 1) + ". " + val.ma.content}</option>);
                    }
                })
            }

            return (
                <Row>
                    <Col>
                        <Form>
                            <Form.Group controlId="form2">
                                <Form.Label>挑選選項 (出發點)</Form.Label>
                                <Form.Control as="select" multiple="true">
                                    {tmp}
                                </Form.Control>
                            </Form.Group>
                            <Button variant="primary" type="submit"
                                disabled={!((currentOpIdAry.length > 0) && (targetQid >= 0))}
                                onClick={onAddRule}>
                                新增跳題
                            </Button>
                        </Form>
                    </Col>
                    <Col>
                        <Form>
                            <Form.Group controlId="form3">
                                <Form.Label>跳轉至.... (目的地)</Form.Label>
                                <Form.Control as="select" multiple>
                                    {tmp2}
                                </Form.Control>
                            </Form.Group>
                        </Form>
                    </Col>
                </Row>

                // <Table striped bordered hover>
                //     <thead>
                //         <tr>
                //             <th>題目</th>
                //             <th>選項</th>
                //             <th>優先跳題</th>
                //             <th>跳題目的地</th>
                //         </tr>
                //     </thead>
                //     <tbody>
                //         {tmp}
                //     </tbody>
                // </Table >
            )
        } catch (e) {
            console.error(e.stack);
            return <div>aa</div>
        }
    }

    function onRuleRemove(data) {
        // console.log(data);
        let qid = data.qid;
        let ruIndex = data.ruIndex;
        let tmp = [...tmpItems];
        let defaultQid = qid + 2;
        try {
            tmp[qid].ru.route.ta[ruIndex] = defaultQid;
            // console.log(tmp);
            // if (Enums.E_QUESTION_TYPE.MULTIPLE == tmp[qid].cf.q_type) { //複選
            //     tmp[qid].ru.route.pr = defaultQid;
            // }
            dispatch({ type: "UPDATE_TMP_ITEM", data: tmp });
        } catch (e) {
            console.warn("[onRuleRemove]", e.stack);
        }
    }

    function renderResult() {
        let tmp = [];
        try {
            tmpItems.forEach((qData, qid) => {
                // console.log(qData, qid);
                let defaultQid = qid + 2;
                let ruAry = qData.ru.route.ta;

                if (ruAry) {
                    let i = 0;
                    ruAry.forEach((val, index) => {
                        if (defaultQid != val) {
                            // console.log(qid, index);
                            tmp.push(<tr key={"re-q" + qid + "-op" + index}>
                                <td>{i == 0 ? "題目" + (qid + 1) : ""}</td>
                                <td>{"op-" + (index + 1) + " -> " + val}</td>
                                <td><Trash2Fill data-qid={qid} data-ruIndex={index} onClick={() => onRuleRemove({ qid: qid, ruIndex: index })} /></td>
                            </tr>);
                            i++;
                        }
                    });
                    // console.log(defaultQid, ruAry, tmp);
                }
            })
        } catch (e) {
            tmp = [];
            console.warn("[renderResult]", e.stack);
        }

        if (tmp.length > 0) {
            return (
                <>
                    <label className="mt-3">已設定跳題</label>
                    <Table striped bordered hover>
                        <tbody>{tmp}</tbody>
                    </Table>
                </>
            )
        } else {
            return (
                <label className="mt-3">不需跳題</label>
            )
        }
    }

    function onPageChange(e) {
        // console.log(e.target.value);
        setTmpPage(e.target.value);
    }

    function onEndEditing() {

        try {
            let inputAry = tmpPage.split(",");
            //let qid = currentQid;
            let tmp = JSON.parse(JSON.stringify(tmpItems));
            for(let i=0; i<tmp.length; i++){
                tmp[i].cf.parameters.page = 0;
            }
            for(let i=0; i<inputAry.length; i++){
                inputAry[i] = parseInt(inputAry[i].trim())-1;
                if(tmp.length > inputAry[i] ) tmp[inputAry[i]].cf.parameters.page = 1;
            }
            // console.log(tmp);

            dispatch({ type: "UPDATE_TMP_ITEM", data: tmp });
        } catch (e) {
            console.warn(e.stack);
        }
    }

    function render() {

        return (
            <>
                {/* <div>{currentQid}</div>
                <div>{currentOpIdAry}</div>
                <div>{targetQid}</div> */}
                {renderNewRuleQuestion()}
                {renderNewRuleOptions()}
                {renderResult()}
                <Row className="text-left mb-3">
                    <Col xs={8} md={7} lg={6}>分頁(請輸入要開始新的一頁的頁碼)</Col>
                    <Col xs={4} md={5} lg={6}><input className="w-100" value={tmpPage} onChange={onPageChange} onEndEditing={onEndEditing}/></Col>
                </Row>
                <Row className="text-center">
                    <Col><Button onClick={props.onSaveAndBack}>儲存<br />(回專案列表)</Button></Col>
                    <Col><Button onClick={props.onNext}>設定完成，<br />下一步</Button></Col>
                </Row>
            </>
        );
    }
    return render();
}
